// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"e62aabb7f3eeac8da8b8","338":"5cf8ccb2f4d6167c1194","777":"ef92a91ecba655c25ad6"}[chunkId] + ".v2.chunk.js";
};